import { render, staticRenderFns } from "./message-thread.vue?vue&type=template&id=03d856d8&scoped=true"
import script from "./message-thread.vue?vue&type=script&lang=js"
export * from "./message-thread.vue?vue&type=script&lang=js"
import style0 from "./message-thread.vue?vue&type=style&index=0&id=03d856d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d856d8",
  null
  
)

export default component.exports